module.exports = "/_next/static/videos/video-xl-eee8c9174ea1395876381d7d7dc2c0a9.mp4";